"use strict";

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

var _ = require("lodash");
var deprecate = require("depd")("@auex/utilities");
var createFragment;

/**
 * Transform a string with token to react component.
 *
 * @param  {object} oldReact (Deprecated) React instance.
 * @param  {string} phrase   String containing the tokens to transform.
 * @param  {object} tokenMap Token list and transformer.
 *         {[token: string]: (node) => node}.
 * @return {node}            Renderable node in React.
 */
function stringToReact(oldReact, phrase, tokenMap) {
  // If we put this outside the function, we'll get a crash when working with
  // symlinks in development. It shouldn't affect performance anyway.
  // FIXME: Mocking here until we change our test system or figure out how to
  // mock properly with all the AMD and Dojo shenanigans.
  if (process.env.TEST_ENV === "intern") {
    createFragment = require("../../tests/stubs/createFragment");
  } else {
    createFragment = require("react-addons-create-fragment");
  }

  // FIXME: Remove deprecation notice in next version.
  if ((typeof oldReact === "undefined" ? "undefined" : (0, _typeof3.default)(oldReact)) === "object" && oldReact.PropTypes) {
    console.warn("stringToReact no longer expects an instance of React. Just call it" + " with phrase and tokenMap.");
  } else {
    tokenMap = phrase;
    phrase = oldReact;
  }

  // Nothing to do, early exit
  if (_.isEmpty(tokenMap)) {
    return phrase;
  }

  // Get a list of tokens to transform
  var tokens = (0, _keys2.default)(tokenMap);

  var tokensGroup = "(" + tokens.join("|") + ")";

  // FIXME: Leverage ES6 template literals.
  // Create the RegEx template, see http://regexr.com/3b940 for example
  // and reference.
  var matcherTemplate = _.template("^(.*?)<${tokensGroup}(?:(?: ?\\/>)|(?:>(.*)<\\/\\2>))(.*)$");
  var matcher = new RegExp(matcherTemplate({ tokensGroup: tokensGroup }));

  function match(subPhrase) {
    var res = matcher.exec(subPhrase);

    if (res) {
      var before = res[1];
      var matchedToken = res[2];
      var part = res[3]; // eslint-disable-line no-magic-numbers
      var after = res[4]; // eslint-disable-line no-magic-numbers

      // Empty group return empty string,
      // optimize by not fragmenting empty strings
      return createFragment({
        before: before ? before : undefined,
        inside: tokenMap[matchedToken](match(part)),

        // Order is important here. See
        // https://facebook.github.io/react/docs/create-fragment.html
        //
        // "and the order of the object's keys is used to determine the order of
        // the rendered children […] Note also that we're relying on the
        // JavaScript engine preserving object enumeration order here, which is
        // not guaranteed by the spec but is implemented by all major browsers
        // and VMs for objects with non-numeric keys."
        //
        // eslint-disable-next-line sort-keys
        after: after ? match(after) : undefined
      });
    }

    // No token found in that phrase, simply return it
    return subPhrase;
  }

  return match(phrase);
};

module.exports = deprecate.function(stringToReact, "'stringToReact' is deprecated in this module. Please use" + " '@novivia/utilities/formats/stringToReact' instead.");


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/formats/stringToReact.js
// module id = 874
// module chunks = 6